// extracted by mini-css-extract-plugin
export default {"inlineWrapper":"LandscapeProjectsImpactTargetOrganism_inlineWrapper__lQES6","wrapper":"LandscapeProjectsImpactTargetOrganism_wrapper__z+zsk"};